import React from 'react';
import './spinner.scss';

const ActivityIndicator = () => {
  return (
    <div className='w-full grid place-items-center'>
      <div className='lds-spinner lds-neutral'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
export default ActivityIndicator;
